module.exports = __webpack_public_path__ + "img/thumb_settings_general.8bae0fcc.jpg";